<template>
  <div>
    <b-card no-body>
      <b-card-body>
        <div class="d-flex justify-content-between  flex-wrap">
          <b-form-group label-for="filterInput" class="mb-0">
            <b-button variant="gradient-primary" size="sm" class="mr-1" @click="traerResponsables" :disabled="loading">
              <font-awesome-icon icon="fa-solid fa-arrows-rotate" :spin="loading" />
            </b-button>
            <!--
            <b-button v-if="$can('create', 'Pr Man Lotes')" variant="gradient-primary" size="sm" class="mr-1">
              <font-awesome-icon icon="fa-solid fa-plus" />
            </b-button>
            -->
            <b-button v-if="$can('create', 'Pr Man Lotes')" variant="gradient-primary" size="sm" class="mr-1"
              @click="exportarExcel">
              <font-awesome-icon icon="fa-solid fa-file-excel" />
            </b-button>
          </b-form-group>
          <b-form-group label-for="filterInput" class="mb-0">
            <b-input-group size="sm">
              <b-form-input id="filterInput" v-model="filter" type="search" placeholder="Buscar" />
              <b-input-group-append>
                <b-button :disabled="!filter" @click="filter = ''">
                  Borrar
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </div>

        <!--
        <b-row>
          <b-col lg="2">
            <b-form-group
                label-for="filterInput"
                class="mb-0"
            >
              <b-button
                  variant="gradient-primary"
                  size="sm"
                  class="mr-1"
                  @click="traerResponsables"
              >
                <font-awesome-icon icon="fa-solid fa-arrows-rotate" :spin="loading"/>
              </b-button>
              <b-button
                  variant="gradient-primary"
                  size="sm"
                  class="mr-1"
              >
                <font-awesome-icon icon="fa-solid fa-plus"/>
              </b-button>
              <b-button
                  variant="gradient-primary"
                  size="sm"
              >
                <span v-if="loading2"> Generando Archivo..&emsp;<b-spinner style="width: 16px; height: 16px;" /></span>
                <span v-else>
              <font-awesome-icon icon="fa-solid fa-file-excel"/>
            </span>


              </b-button>
            </b-form-group>
          </b-col>
        </b-row>
        -->

      </b-card-body>

      <b-table hover responsive sticky-header="58vh" class="position-relative" :items="items" :fields="fields"
        :filter="filter" :filter-included-fields="filterOn" :busy="loading" show-empty
        empty-text="No se encontraron datos en esta tabla."
        emptyFilteredText="No se encontraron datos con los parámetros ingresados.">
        <template #table-busy>
          <div class="text-center text-dark my-1">
            <b-spinner class="align-middle"></b-spinner> &emsp;
            <strong>Obteniendo datos...</strong>
          </div>
        </template>
        <template #cell(estado)="data">
          <b-badge :variant="status[1][parseInt(data.value)]">
            {{ status[0][parseInt(data.value)] }}
          </b-badge>
        </template>
        <template #cell(acciones)="data">
          <div class="text-nowrap">
            <feather-icon :id="`btn_${data.item.id}_editar`" icon="EditIcon" size="16" class="mr-1"
              @click="mostrarModalEditar(data.item)" />
            <b-tooltip title="Editar registro" :target="`btn_${data.item.id}_editar`" />
          </div>
        </template>
      </b-table>
    </b-card>

    <b-modal id="modal-editar" ref="modal-editar" v-model="modalShowEditar" title="Editar Registro" ok-title="Editar"
      cancel-title="Cerrar" :cancel-disabled="loadingEditar" :ok-disabled="loadingEditar" no-close-on-esc
      no-close-on-backdrop centered size="lg" @ok="okModalEditar">
      <div v-if="loadingEditar" align="center">
        <p>Editando registro ... </p>
        <b-spinner label="Loading..." variant="primary" />
      </div>
      <div v-else>
        <validation-observer ref="editarResponsables">
          <b-form autocomplete="off" @submit.prevent="editarRegistro">
            <b-row>
              <b-col lg="6">
                <b-form-group label="Nombres" label-for="nombres">
                  <b-form-input id="nombres" v-model="dataArray.con_usuario.first_name" disabled />
                </b-form-group>
              </b-col>
              <b-col lg="6">
                <b-form-group label="Apellidos" label-for="apellidos">
                  <b-form-input id="apellidos" v-model="dataArray.con_usuario.last_name" disabled />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col lg="6">
                <b-form-group label="DNI" label-for="dni">
                  <b-form-input id="dni" v-model="dataArray.con_usuario.dni" disabled />
                </b-form-group>
              </b-col>
              <b-col lg="6">
                <b-form-group label="Usuario" label-for="usuario">
                  <b-form-input id="usuario" v-model="dataArray.con_usuario.username" disabled />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col lg="6">
                <b-form-group label="Seleccionar Estado" label-for="estado">
                  <v-select id="estado" v-model="dataArray.estado" :reduce="estados => estados.value" label="text"
                    key="value" :options="estados" :clearable="false" />
                </b-form-group>
              </b-col>
              <b-col lg="6">
                <b-form-group label="Seleccionar Empresa" label-for="vue-select">
                  <v-select id="rol" v-model="dataArray.empresa" :options="empresas" :clearable="false" />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col lg="6">
                <b-form-group label="Seleccionar Cultivo" label-for="cultivo">
                  <validation-provider #default="{ errors }" name="Cultivo" vid="cultivo" rules="required">
                    <v-select id="cultivo" v-model="dataArray.cultivo" :options="cultivos" multiple
                      @input="cambiarSelectCultivo" :clearable="false" />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col lg="6">
                <b-form-group label="Seleccionar Rol" label-for="vue-select">
                  <v-select id="rol" v-model="dataArray.rol" :options="roles" :clearable="false" />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col lg="6">
                <b-form-group label="Sem. Actual Día" label-for="vue-select">
                  <v-select id="rol" v-model="dataArray.valor" :options="diasSem" :clearable="false" />
                </b-form-group>
              </b-col>
              <b-col lg="6">
                <b-form-group label="Sem. Actual Hora" label-for="hora1">
                  <validation-provider #default="{ errors }" name="Sem. Actual Hora" vid="hora1" rules="required">
                    <b-form-timepicker id="hora1" v-model="dataArray.valor_1" v-bind="espanol" now-button reset-button
                      locale="en" />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col lg="6">
                <b-form-group label="Sem. Sgte. Día" label-for="vue-select">
                  <v-select id="rol" v-model="dataArray.valor_2" :options="diasSem" :clearable="false" />
                </b-form-group>
              </b-col>
              <b-col lg="6">
                <b-form-group label="Sem. Sgte. Hora" label-for="hora2">
                  <validation-provider #default="{ errors }" name="Sem. Sgte. Hora" vid="hora2" rules="required">
                    <b-form-timepicker id="hora2" v-model="dataArray.valor_3" v-bind="espanol" now-button reset-button
                      locale="en" />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col lg="6">
                <b-form-group label="Seleccionar Modulo" label-for="modulo">
                  <validation-provider #default="{ errors }" name="Modulo" vid="modulo" rules="required">
                    <v-select id="modulo" v-model="dataArray.modulo" :options="modulos" multiple
                      @input="cambiarSelectModulo" :clearable="false" />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </div>
    </b-modal>
  </div>
</template>

<script>

import {
  BBadge,
  BButton,
  BCard,
  BCardBody,
  BFormGroup,
  BFormInput,
  BInputGroup,
  BInputGroupAppend, BSpinner,
  BTable, BTooltip,
  BModal,
  BForm,
  BRow,
  BCol,
  BFormTimepicker,
} from 'bootstrap-vue'
import axiosIns from '@/libs/axios'
import vSelect from 'vue-select'
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
import { required } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent'

export default {
  components: {
    BCard,
    BCardBody,
    BFormGroup,
    BButton,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BTable,
    BTooltip,
    BSpinner,
    BBadge,
    BModal,
    BForm,
    BRow,
    BCol,
    BFormTimepicker,

    vSelect,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {},
  data() {
    return {
      loading: false,
      loadingEditar: false,
      items: [],
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      fields: [
        {
          key: 'acciones',
          label: '# ',
          thClass: 'py-1 alinear-medio',
          tdClass: 'px-1',
          class: 'text-center',
          stickyColumn: true
        },
        {
          key: 'estado',
          label: 'estado',
          sortable: true,
          thClass: 'py-1 alinear-medio',
          tdClass: 'px-1 alinear-una-sola-linea',
        },
        {
          key: 'con_usuario.first_name',
          label: 'nombres',
          sortable: true,
          thClass: 'py-1 alinear-medio',
          tdClass: 'px-1 alinear-una-sola-linea',
        },
        {
          key: 'con_usuario.last_name',
          label: 'apellidos',
          sortable: true,
          thClass: 'py-1 alinear-medio',
          tdClass: 'px-1 alinear-una-sola-linea',
        },
        {
          key: 'con_usuario.dni',
          label: 'dni',
          sortable: true,
          thClass: 'py-1 alinear-medio',
          tdClass: 'px-1 alinear-una-sola-linea',
        },
        {
          key: 'con_usuario.username',
          label: 'Usuario',
          sortable: true,
          thClass: 'py-1 alinear-medio',
          tdClass: 'px-1 alinear-una-sola-linea',
        },
        {
          key: 'empresa',
          label: 'empresa',
          sortable: true,
          thClass: 'py-1 alinear-medio',
          tdClass: 'px-1 alinear-una-sola-linea',
        },
        {
          key: 'modulo',
          label: 'modulo',
          sortable: true,
          thClass: 'py-1 alinear-medio',
          tdClass: 'px-1 alinear-una-sola-linea',
        },
        {
          key: 'cultivo',
          label: 'cultivo',
          sortable: true,
          thClass: 'py-1 alinear-medio',
          tdClass: 'px-1 alinear-una-sola-linea',
        },
        {
          key: 'rol',
          label: 'rol',
          sortable: true,
          thClass: 'py-1 alinear-medio',
          tdClass: 'px-1 alinear-una-sola-linea',
        },
        {
          key: 'valor',
          label: 'Sem. Actual Día',
          sortable: true,
          thClass: 'py-1 alinear-medio',
          tdClass: 'px-1 alinear-una-sola-linea',
        },
        {
          key: 'valor_1',
          label: 'Sem. Actual Hora',
          sortable: true,
          thClass: 'py-1 alinear-medio',
          tdClass: 'px-1 alinear-una-sola-linea',
        },
        {
          key: 'valor_2',
          label: 'Sem. Sgte. día',
          sortable: true,
          thClass: 'py-1 alinear-medio',
          tdClass: 'px-1 alinear-una-sola-linea',
        },
        {
          key: 'valor_3',
          label: 'Sem. Sgte. Hora',
          sortable: true,
          thClass: 'py-1 alinear-medio',
          tdClass: 'px-1 alinear-una-sola-linea',
        },
      ],
      status: [
        {
          0: 'Activo',
          1: 'Inactivo',
        },
        {
          0: 'light-success',
          1: 'light-danger',
        }
      ],

      estados: [
        { value: "0", text: "Activo" },
        { value: "1", text: "Inactivo" }
      ],

      modalShowEditar: false,

      // roles: ['ADMINISTRADOR', 'APROBADOR', 'USUARIO'],
      roles: ['JEFE DE RIEGO CORPORATIVO', 'JEFE DE RIEGO', 'USUARIO'],
      empresas: ['TODOS', 'AGROVISION PERÚ S.A.C', 'ARENA VERDE'],
      cultivos: ['TODOS', 'ARÁNDANO', 'UVA', 'PALTA', 'ESPÁRRAGO', 'LIMÓN'],
      modulos: ['RIEGO','FERTILIZACION'],
      diasSem: ['LUNES', 'MARTES', 'MIÉRCOLES', 'JUEVES', 'VIERNES', 'SÁBADO', 'DOMINGO'],

      dataArray: {
        id: null,
        con_usuario: {
          id: null,
          username: null,
          first_name: null,
          last_name: null,
          dni: null
        },
        empresa: null,
        cultivo: null,
        rol: null,
        valor: null,
        valor_1: null,
        valor_2: null,
        valor_3: null,
        estado: null,
        modulo:null,
      },

      espanol: {
        labelHours: 'Hora',
        labelMinutes: 'Minuto',
        labelSeconds: 'Segundos',
        labelIncrement: 'Erhöhen',
        labelDecrement: 'Verringern',
        labelSelected: 'Ausgewählte Zeit',
        labelNoTimeSelected: 'Seleccione Hora',
        labelCloseButton: 'Cerrar',
        labelResetButton: 'Borrar',
        labelNowButton: 'Ahora',
      },

      required,
    }
  },
  computed: {},
  mounted() {
    this.traerResponsables();
    localize("es");
  },
  methods: {
    traerResponsables() {
      const yo = this
      yo.loading = true

      const config = {
        method: 'get',
        url: '/pagricolas/responsables/'
      }

      axiosIns(config)
        .then(function (response) {
          if (response.status === 200) {
            yo.items = response.data;
          }
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(function () {
          yo.loading = false
        })

    },

    mostrarModalEditar(arrData) {
      const yo = this
      const culti = arrData.cultivo.split(", ")

      yo.modalShowEditar = true
      yo.dataArray = {
        id: arrData.id,
        con_usuario: {
          id: arrData.con_usuario.id,
          username: arrData.con_usuario.username,
          first_name: arrData.con_usuario.first_name,
          last_name: arrData.con_usuario.last_name,
          dni: arrData.con_usuario.dni,
        },
        empresa: arrData.empresa,
        cultivo: culti,
        rol: arrData.rol,
        valor: arrData.valor,
        valor_1: arrData.valor_1,
        valor_2: arrData.valor_2,
        valor_3: arrData.valor_3,
        estado: arrData.estado,
        modulo: arrData.modulo,
      }
    },

    cambiarSelectCultivo() {
      if (this.dataArray.cultivo[0] === "TODOS") {
        this.dataArray.cultivo = this.dataArray.cultivo.splice(1, 1)
      }
      if (this.dataArray.cultivo.includes("TODOS")) {
        this.dataArray.cultivo = ["TODOS"]
      }
    },


    cambiarSelectModulo() {

      if(this.dataArray.modulo.length>0){
        this.dataArray.modulo.sort((a, b) => b.localeCompare(a));
        if(this.dataArray.modulo[0].includes(",")){
          this.dataArray.modulo=this.dataArray.modulo[1]
        }
      }

    },

    editarRegistro() {
      const yo = this
      this.$refs.editarResponsables.validate().then(success => {
        if (success) {
          yo.loadingEditar = true

          if (Array.isArray(yo.dataArray.modulo)) {
            const joinedModulo = yo.dataArray.modulo.join(", ");
            yo.dataArray.modulo = '';
            yo.dataArray.modulo = joinedModulo;
          }

          const data = JSON.stringify({
            'empresa': yo.dataArray.empresa,
            'cultivo': yo.dataArray.cultivo.join(", "),
            'rol': yo.dataArray.rol,
            'valor': yo.dataArray.valor,
            'valor_1': yo.dataArray.valor_1,
            'valor_2': yo.dataArray.valor_2,
            'valor_3': yo.dataArray.valor_3,
            'estado': yo.dataArray.estado,
            'con_usuario': yo.dataArray.con_usuario.id,
            'modulo': yo.dataArray.modulo,
          })

          const config = {
            method: 'put',
            url: 'pagricolas/responsables/editar/' + yo.dataArray.id,
            headers: {
              'Content-Type': 'application/json'
            },
            data: data
          }

          axiosIns(config)
            .then(function (response) {
              if (response.status === 200) {
                yo.mostrarNotificacion('¡Bien hecho!', 'CheckIcon', "El registro se editó correctamente.", 'success', 5000)
              }
            })
            .catch(function (error) {
              console.log(error);
              yo.mostrarNotificacion('Error en la edición.', 'BellIcon', error.toString(), 'danger', 5000)
            })
            .finally(function () {
              yo.traerResponsables()
              yo.$nextTick(() => {
                yo.$refs['modal-editar'].toggle('#toggle-btn')
              })
              yo.loadingEditar = false
            })

        }
      })
    },

    okModalEditar(bvModalEvt) {
      bvModalEvt.preventDefault()

      this.editarRegistro()
    },

    mostrarNotificacion(titulo, icono, texto, variante, tiempo) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: titulo,
          icon: icono,
          text: texto,
          variant: variante
        }
      },
        {
          timeout: tiempo,
          position: 'top-center',
        })
    },

    exportarExcel() {
      const yo = this
      yo.loading_exp = true
      const data = JSON.stringify(
        {
          "datas": yo.items
        }
      )
      const config = {
        method: 'post',
        url: '/pagricolas/responsables/exportar/filter/',
        headers: {
          'Content-Type': 'application/json'
        },
        responseType: 'arraybuffer',
        data: data
      };

      axiosIns(config)
        .then(function (response) {
          if (response.status === 200) {
            const fileURL = window.URL.createObjectURL(new Blob([response.data]));
            const fileLink = document.createElement('a');
            fileLink.href = fileURL;
            fileLink.setAttribute('download', "responsables.xlsx");
            document.body.appendChild(fileLink);
            fileLink.click();

            yo.$toast({
              component: ToastificationContent,
              props: {
                title: 'Archivo creado',
                icon: 'CheckIcon',
                text: 'El archivo se creó satisfactoriamente.',
                variant: 'success',
              },
            },
              {
                position: 'top-center',
              })
          }
        })
        .catch(function (error) {
          console.log(error);
          yo.$toast({
            component: ToastificationContent,
            props: {
              title: 'Error en la creación del archivo',
              icon: 'XIcon',
              text: 'Hubo un error en la creación del archivo, intentelo nuevamente en unos minutos.',
              variant: 'danger',
            },
          })
        })
        .finally(function () {
          yo.loading_exp = false
        });
    }
  },
}
</script>

<style lang="scss">
.alinear-una-sola-linea,
.alinear-medio {
  white-space: nowrap !important;
}

.alinear-medio {
  vertical-align: middle !important;
}
</style>
